import React from "react";
import { Header } from "../../components/ui/Header";
import Typograpy from "../../components/ui/Typography";
import Button from "../../components/ui/Button";
import { getFixerRates } from "../../services/home";
import CurrencyCard from "../../components/ui/CurrencyCard";
import { HomepageIcon } from "../../assets/Icons";
import { useNavigate, useLocation } from "react-router-dom";
// import { decryptData } from "../../utils";
import Clarity from '@microsoft/clarity';
import MixpanelConfig from "../../constants/MixpanelConfig";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { remittanceActions } from "../remittance-beta/state/remittanceSlice";


const Homepage = () => {
  const symbols = [
    "USD",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "NZD",
    "AED",
    // "SAR",
    // "MUR",
    "JPY",
    "CHF",
  ];

  const [latestRates, setLatestRates] = React.useState<object[]>([]);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  
  const router = useLocation()
  const symbolsString = symbols.toString() as string;

  // const cipher =
  //   "4f1694bb63211f308abe5a6894d81e44335b5697564bf6a0d1a6812785b3123b9110e403fa86022aab8f4e552c79d49149d3672692052e5798e2fb1ba8250241fd35ba5fafbcfb25ef763b15b1ad778418b97cc2e8e6e9ec1b8523024487b4878d9eda03917cbad1142b50f6a3104d10b63c6bf13ae7b532e93d23ee802bd887376061b3a07bedc6a32ea141db20114cfb848e67da8ef880150b";

  // React.useEffect(() => {
  //   const data: any = decryptData(cipher);
  //   window.console.log(data, "sssssss");
  // }, []);

  React.useEffect(() => {
    MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Homescreen_Landing, {})
  }, []);

  React.useEffect(() => {
    getFixerRates(symbolsString).then((response: any) => {
      const data = response.data.rates;

      const object = Object.keys(data).map((item) => {
        return {
          [item]: data[item],
          currencyRate: data[item],
          image: `${item}.png`,
        };
      });
      setLatestRates(object);
    });
  }, []);


  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (clarityProjectId) {
    Clarity.init(clarityProjectId);
    const currentUserString = localStorage.getItem("currentUser");
    if (currentUserString) {
      const currentUser = JSON.parse(currentUserString);
      Clarity.identify(currentUser.phoneNumber)
      Clarity.setTag("User ID", currentUser.phoneNumber)
      Clarity.setTag("Name", currentUser.username)
      Clarity.setTag("Email", currentUser.username)
      Clarity.setTag("Phone Number", currentUser.phoneNumber)
      Clarity.setTag("Screen Name", router.pathname)
    }
  }

  const everestPartner = localStorage.getItem("everestPartner")

  return (
    <div className="flex flex-col">
      <div
        style={{ position: "absolute", top: "120px" }}
        className="2xl:left-[400px] overflow-clip self-end"
      >
        <HomepageIcon className="overflow-clip" />
      </div>
      <div style={{ zIndex: 50 }}>
        <Header />
      </div>
      <div className="z-20 px-40 pt-36">
        <Typograpy tagType="h2" className="mb-1 text-3xl font-medium">
          Cross-border payments made
        </Typograpy>
        <Typograpy tagType="h2" className="text-5xl font-semibold w-[20%] leading-[1.02]">
          Smarter, Faster, Better.
        </Typograpy>
        <Button
          bgColor="bg-primary-200"
          fontStyle={{
            fontColor: "text-white",
            fontSize: "text-[20px]",
          }}
          className="px-12 py-2 mt-8 font-semibold rounded-md cursor-pointer"
          onClickHandler={() => {
            if(authState?.currentUser?.username?.includes("moneyhop.co")) {
              dispatch(remittanceActions.resetRemittanceState());
              navigate("/send/calculator");
              MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline_Beta, {});
            } else {
              navigate("/remittance");
              MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline, {});
            }
          }}
        >
          Get started
        </Button>
        <div className="mt-2">
          Document Requirements as per purpose code -{" "}
          <a
            href="https://hopapp-static-resources.s3.ap-south-1.amazonaws.com/Supporting+Documents.pdf"
            rel="nofollow noindex noreferrer"
            target="_blank"
          >
            <span className="text-blue-700">Download now</span>
          </a>
        </div>
      </div>
      {everestPartner === "true" ? null :
        <div className="z-20 absolute bottom-[-7%] left-[5%] w-[90%] m-auto font-poppins">
          <div className=" w-full bg-[#DAE1EC] rounded-t-lg flex flex-col items-center p-4">
            <div className="flex items-center mt-1 mb-6">
              <span>
                <img
                  src={require(`../../assets/Icons/country-flag-icons/INR.png`)}
                  alt=""
                  style={{ width: 35, marginRight: 10 }}
                  className="border-4 rounded-full border-white-100"
                />
              </span>
              <Typograpy tagType="div" className="text-[21px]">
                Currency rates worldwide
              </Typograpy>
            </div>
            <div className="flex flex-wrap items-center w-full justify-center">
              {latestRates.length > 0 ? (
                latestRates.map((items: any, i) => {
                  return (
                    <CurrencyCard
                      cardClassname="mr-4 mb-4 w-fit"
                      icon={items.image}
                      currencyRate={parseFloat((1 / items.currencyRate).toFixed(3))}
                      key={i}
                    />
                  );
                })
              ) : (
                <div style={{ marginTop: 20 }}>
                  {/* <CircularProgress /> */}
                  Loading...
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Homepage;
